import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { ActualValue, IconCheck, OriginalValue } from './styles';
import { BracketsTable, BracketsTableContentDescription } from '../BracketsTable';
export var FeeBracketsTable = function (_a) {
  var title = _a.title,
    tableData = _a.tableData;
  var theme = useTheme();
  var feeData = tableData.map(function (_a) {
    var isCurrentFee = _a.isCurrentFee,
      description = _a.description,
      originalValue = _a.originalValue,
      actualValue = _a.actualValue;
    return {
      description: _jsxs(_Fragment, {
        children: [isCurrentFee && _jsx(IconCheck, {
          size: 24,
          type: "icon-check",
          color: theme.tokens.interface.feedback.positive.regular
        }), _jsx(BracketsTableContentDescription, {
          children: description
        })]
      }),
      value: _jsxs(_Fragment, {
        children: [_jsx(ActualValue, {
          isDiscounted: !!originalValue,
          children: actualValue
        }), originalValue && _jsx(OriginalValue, {
          children: originalValue
        })]
      })
    };
  });
  return _jsx(BracketsTable, {
    title: title,
    tableData: feeData
  });
};